<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
              [dataProviderParams]="dataProviderParams" [dataProvider]="groupService" [title]="title">
  </data-table>
</page-content>
